<template>
    <!-- Conteneur principal RELATIVE pour positionner la barre de titre -->
    <div
      class="relative w-full overflow-hidden"
      :class="{ 'h-screen': !campagneId, 'h-full': campagneId }"
    >
      <MapsComponent
        v-if="dataInfo" 
        :routes="itineraires"
      />
        
      <test />
      <!-- Message d'absence de données sur la carte -->
      <div
        v-if="routes.length === 0 && !isLoading && errorMessage"
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded-lg shadow-md z-10 text-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-12 w-12 mx-auto text-red-400 mb-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M12 20a8 8 0 100-16 8 8 0 000 16z"
          />
        </svg>
        <h3 class="text-lg font-semibold text-gray-700">
          Aucun trajet disponible
        </h3>
        <p class="text-gray-600 mt-1">{{ errorMessage }}</p>
        <p class="text-gray-500 text-sm mt-3">
          Les configurations pour localiser les supports n'ont pas été initialisées
          avant le démarrage de cette activité.
        </p>
      </div>
  
      <!-- Barre de Titre Positionnée par-dessus la carte -->
      <div
        v-if="!this.campagneId"
        class="absolute top-4 left-1/2 transform -translate-x-1/2 z-1 bg-[#488478] flex items-center py-2 rounded-lg shadow-md"
      >
        <button
          @click="goBack"
          class="mr-3 text-white focus:outline-none hover:opacity-80 px-8"
        >
          <svg
            width="21"
            height="19"
            viewBox="0 0 21 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.03449 8.28427C0.713073 8.60715 0.532623 9.04419 0.532623 9.49977C0.532623 9.95536 0.713073 10.3924 1.03449 10.7153L7.90949 17.5903C8.06911 17.7499 8.25861 17.8765 8.46717 17.9629C8.67572 18.0493 8.89925 18.0938 9.12499 18.0938C9.58089 18.0938 10.0181 17.9126 10.3405 17.5903C10.6629 17.2679 10.844 16.8307 10.844 16.3748C10.844 15.9189 10.6629 15.4816 10.3405 15.1593L6.39974 11.2185H18.75C19.2058 11.2185 19.643 11.0374 19.9653 10.7151C20.2877 10.3928 20.4687 9.95561 20.4687 9.49977C20.4687 9.04393 20.2877 8.60676 19.9653 8.28443C19.643 7.9621 19.2058 7.78102 18.75 7.78102H6.39974L10.3405 3.84027C10.5001 3.68065 10.6267 3.49115 10.7131 3.2826C10.7995 3.07404 10.844 2.85051 10.844 2.62477C10.844 2.39903 10.7995 2.17551 10.7131 1.96695C10.6267 1.75839 10.5001 1.56889 10.3405 1.40927C10.1809 1.24965 9.99137 1.12303 9.78281 1.03664C9.57426 0.950258 9.35073 0.905798 9.12499 0.905798C8.89925 0.905798 8.67572 0.950258 8.46717 1.03664C8.25861 1.12303 8.06911 1.24965 7.90949 1.40927L1.03449 8.28427Z"
              fill="white"
            />
          </svg>
        </button>
        <h1
          class="text-white text-base md:text-lg font-semibold whitespace-nowrap sm:px-8 md:px-40 lg:px-80"
        >
          {{ campagne?.title || "Campagne en cours..." }}
        </h1>
      </div>
  
      <!-- Les trajets à afficher -->
      <div
        v-if="routes.length > 0"
        class="absolute bottom-4 bg-white p-3 left-4 rounded-lg shadow-md z-1"
      >
        <h3 class="font-semibold mb-2">Trajets disponibles</h3>
        <div
          v-for="(route, index) in routes"
          :key="`control-${index}`"
          class="flex items-center mb-2"
        >
          <label :for="`route-${index}`" class="flex items-center">
            <span
              class="inline-block w-4 h-4 mr-2"
              :style="`background-color: ${route.options.strokeColor}`"
            ></span>
            {{ route.name }}
          </label>
          <div
            v-if="route.startLocation"
            class="ml-2 text-xs text-gray-600 flex items-center"
          >
            <!-- Petit indicateur visuel pour le point de départ -->
            <svg width="12" height="12" viewBox="0 0 24 24" class="mr-1">
              <path
                fill="#32CD32"
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              />
            </svg>
            Départ: {{ route.startLocation }}
          </div>
        </div>
      </div>
  
      <!-- Indicateur de chargement -->
      <div
        v-if="isLoading"
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white bg-opacity-80 p-3 rounded-lg shadow-md z-10 flex items-center"
      >
        <svg
          class="animate-spin h-5 w-5 mr-3 text-gray-700"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span>Chargement des données...</span>
      </div>
    </div>
  </template>
  
  <script>
  import { getDatePositions } from "../../../views/login/API fonctiond/fonctions";
  import allFunctions from "@/components/utilityRequest/allFunctions";
  import MapsComponent from "./MapsComponent.vue";
//   import test from "./test.vue";
  
  export default {
    name: "MapTrajets",
    components: {
      MapsComponent,
    //   test,
    },
    googleMapsOptions: {
      async: true,
    },
    props: {
      selectedDate: {
        type: String,
        default: () => new Date().toISOString().slice(0, 10), // Date par défaut au format YYYY-MM-DD
      },
      campagneId: {
        type: String,
        default: null,
      },

    },
    data() {
      return {
        googleMapsApiKey: "AIzaSyCR2zyPaTlEdVvAnmETWlMx-LDw0ypIDNw",
        mapCenter: { lat: 6.3654, lng: 2.4183 },
        mapZoom: 14,
        googleMap: null,
        // infoWindow: null,
        routes: [],
        dataInfo: null,
        itineraires: [],
        isLoading: false,
        campagne: null,
        errorMessage: "",
        pointIcon: {},
        // startPointIcon: {}, // Icône pour les points de départ normaux
        // startMarkerSVGs: {}, // Stockage des SVG pour les marqueurs de départ personnalisés
      };
    },
    computed: {
      startPoints() {
        const startPoints = [];
        this.routes.forEach((route) => {
          if (
            route.options &&
            route.options.path &&
            route.options.path.length > 0
          ) {
            const firstPoint = route.options.path[0];
            startPoints.push({
              position: { lat: firstPoint.lat, lng: firstPoint.lng },
              address: firstPoint.address || "Départ",
              routeName: route.name,
              routeColor: route.options.strokeColor,
            });
          }
        });
        return startPoints;
      },
    },
    methods: {
      // Générer un SVG dynamique pour le marqueur de départ avec la couleur du trajet
      getStartIcon(color) {
        // Si nous avons déjà créé ce SVG, le retourner du cache
        if (this.startMarkerSVGs[color]) {
          return this.startMarkerSVGs[color];
        }
  
        // Créer un marqueur SVG de type "épingle" avec la couleur du trajet
        const svg = `
            <svg width="22" height="36" viewBox="0 0 22 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 0.269775C5.37944 0.269775 0.822998 4.82621 0.822998 10.4468C0.82708 12.1724 1.26994 13.8688 1.68245 14.6225L11 35.7303L19.9049 15.3763H19.9003C20.7367 13.8679 21.1761 12.1716 21.177 10.4468C21.177 4.82621 16.6206 0.269775 11 0.269775ZM11 5.35821C11.6683 5.35821 12.33 5.48983 12.9473 5.74556C13.5647 6.00129 14.1256 6.37611 14.5981 6.84863C15.0707 7.32116 15.4455 7.88212 15.7012 8.49949C15.9569 9.11687 16.0885 9.77856 16.0885 10.4468C16.0885 11.7963 15.5524 13.0906 14.5981 14.0449C13.6438 14.9991 12.3496 15.5352 11 15.5352C9.65049 15.5352 8.35622 14.9991 7.40195 14.0449C6.44769 13.0906 5.91158 11.7963 5.91158 10.4468C5.91158 9.09726 6.44769 7.803 7.40195 6.84873C8.35622 5.89446 9.65049 5.35836 11 5.35836V5.35821Z" fill="#14AE5C"/>
              <ellipse cx="11" cy="10.5" rx="5" ry="5.5" fill="white"/>
            </svg>
          `;
  
        // Convertir le SVG en URL de données
        const svgUrl =
          "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  
        // Stocker dans le cache
        this.startMarkerSVGs[color] = svgUrl;
  
        return svgUrl;
      },
  
      // Fonction pour charger les positions par date
      async fetchDatePositions() {
        this.isLoading = true;
        this.errorMessage = "";

        // Define the list of colors
        const routeColors = [
            "#FF0000",
            "#0000FF",
            "#008000",
            "#FFA500", 
            "#800080",
            "#00FFFF",
            "#FFC0CB",
            "#A52A2A",
            "#FFFF00",
            "#000000",
            "#808080",
            "#4682B4",
            "#FF6347",
            "#32CD32",
            "#DAA520",
        ];

        try {
          const response = await getDatePositions({
            dateRapport: this.selectedDate,
            campagneId: this.$route.query.id || this.campagneId,
          });
  
          // Vérifier si les données sont vides avant le traitement
          if (
            !response.data ||
            !response.data.positionsPerQrCode ||
            Object.keys(response.data.positionsPerQrCode).length === 0
          ) {
            this.errorMessage =
              "Aucune donnée de trajet disponible pour la date sélectionnée.";
            this.routes = [];
            return;
          }
        //   Récupération des possitions de l'API
          this.dataInfo = response.data
          console.log("Données brutes reçues de l'API:", response.data);
          const data = response.data.positionsPerQrCode
          let colorIndex = 0;
          for(let item in data){
            const obj = {
                name: data[item].qrCode.teamName,
                color: routeColors[colorIndex % routeColors.length],
                points: []
            };
            const position = data[item].positions;
            for(let i in position){
                if (parseFloat(position[i].latitude) > 0 && parseFloat(position[i].longitude) > 0){
                    const info = { 
                        position: {
                            lat: parseFloat(position[i].latitude),
                            lng: parseFloat(position[i].longitude)
                        },
                        name: position[i].address,
                        time: position[i].time,
                    }
                    obj.points.push(info)
                }
            }
            this.itineraires.push(obj)
            console.log('itineraire', this.itineraires)
          }
        //   this.processRouteData(response.data); // Appel de la fonction de traitement
        } catch (error) {
          console.error(
            "Erreur lors du chargement des positions par date:",
            error
          );
          this.errorMessage = "Impossible de charger les positions.";
          this.routes = []; // Vider les routes en cas d'erreur
        } finally {
          this.isLoading = false;
        }
      },
  
      // Fonction pour revenir en arrière dans l'historique
      goBack() {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          console.log("Pas d'historique de navigation.");
        }
      },
  
      async getCampagne() {
        const id = this.$route.query.id || this.campagneId;
        if (!id) {
          console.error("Aucun ID de campagne fourni.");
          return;
        }
        this.campagne = await allFunctions.findOne("campagne", id);
        console.log('Campagne', this.campagne);
      },
    },
    created() {
      if (!this.googleMapsApiKey) {
        console.error(
          "Clé API Google Maps manquante ! Vérifiez VUE_APP_GOOGLE_MAPS_API_KEY."
        );
      }
      this.fetchDatePositions();
      this.getCampagne();
    },
  };
  </script>
  
  <style scoped>
  /* Styles spécifiques au composant (identiques à l'original) */
  .transform {
    transform: translateX(-50%);
  }
  
  .-translate-x-1\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y))
      rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
      scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  </style>